module.exports = __webpack_public_path__ + "img/couple.675e0164.png";